import { atom } from 'jotai';

export const editPatientDetailsModalOpenAtom = atom<boolean>(false);
